module.exports = __webpack_public_path__ + "static/media/lp-img-1.78641ab5.png";